/**
 * Description:
 * 1. Mục đích: code các luồng liên quan đến giao dịch của tài khoản Follower
 */
import inqService from '@/stores/dataManager/apiServices/inqService';
import TransactionService from '@/stores/dataManager/apiServices/transService';
import userDataService from '@/stores/dataManager/apiServices/userDataService';
import { COS_ROLE, STATUS_ACCOUNT } from '@/stores/dataStore/memoryStore/const/constIndex';
import { formatDate } from '@/utilities';
import ToastUtil from '@/views/components/Toast/Toast';
import { DataSeriesArray } from '@/views/elements/chart/LineChartElement';
import i18next from 'i18next';

export type ResponseSuccess = {
    isSuccess: boolean,
    data?: any,
}

export type ResponseSuccessPagination = {
    data: any[]
    pageIndex: number,
    pageSize: number,
    total: number,
}

export const getDataInfoMF = async (accountId: string) => {
    const param = {
        config: {},
        accountId
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await userDataService.getAccountInfoMF(param).then((data: any) => {
        const { baldefovd, monthtraded, netasset, minmonthtraded, custodycd, minnetasset } = data?.[0]
        result = {
            isSuccess: true,
            data: { baldefovd, monthtraded, netasset, minmonthtraded, custodycd, minnetasset }
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getDataInfoMF'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

export const submitRegisterFollower = async (accountId: string, dataVerify: any) => {
    const param = {
        config: {},
        accountId,
        dataVerify,
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await userDataService.registerFollower(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: {}
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.submitRegisterFollower'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

type QueryListMaster = {
    typeOrder: string
    searchQuery?: string
    pageSize: number
    pageIndex: number
    custodycd: string
    mtAcctno?: string
}

export const getListMaster = async ({ typeOrder, searchQuery, pageSize, pageIndex, custodycd, mtAcctno }: QueryListMaster) => {
    const param = {
        config: {},
        typeOrder,
        searchQuery,
        pageSize,
        pageIndex,
        custodycd,
        mtAcctno,
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await inqService.getListMaster(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: {
                data: data?.data ?? [],
                pageIndex: data?.pageIndex ?? 0,
                pageSize: data?.pageSize ?? 0,
                total: data?.total ?? 0,
            },
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getListMaster'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

const prepareDataForChart = (raw: any) => {
    const dataForChart: DataSeriesArray = [
        { id: 'on_date', type: 'XAxis', value: [] },
        { id: 'ar_index', type: 'YAxis', value: [] },
        { id: 'ar', type: 'YAxis', value: [] },
    ]

    for (let index = 0; index < raw.length; index++) {
        const element = raw[index];
        dataForChart?.[0].value.push(formatDate(element.on_date))
        dataForChart?.[1].value.push(element.ar_index)
        dataForChart?.[2].value.push(element.ar)
    }

    return dataForChart
}

export const getInvestPerformancePublic = async (accountId: string, masterAccount: string = '', cosrole: string = COS_ROLE.M, timePeriod: number = 1, timeType: string = "M") => {
    const param = {
        config: {},
        accountId,
        masterAccount,
        cosrole,
        timePeriod,
        timeType
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await inqService.getInvestPerformancePublic(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: prepareDataForChart(data),
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getInvestPerformanceBy'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

export const getInvestPerformancePrivate = async (accountId: string, masterAccount: string = '', cosrole: string = COS_ROLE.M, timePeriod: number = 1, timeType: string = "M") => {
    const param = {
        config: {},
        accountId,
        masterAccount,
        cosrole,
        timePeriod,
        timeType
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await inqService.getInvestPerformancePrivate(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: prepareDataForChart(data),
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getInvestPerformanceBy'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

export const submitCopyMaster = async (body: any, dataVerify: any) => {
    const param = {
        config: {},
        body,
        dataVerify
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await userDataService.copyMaster(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: {}
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.submitCopyMaster'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

export const submitConfigCopyMaster = async (body: { accountId: string, body: any, dataVerify: any }) => {
    const param = {
        config: {},
        body
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await userDataService.updateCopyMaster(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: {}
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.submitConfigCopyMaster'))
        result = {
            isSuccess: false,
        }
    })
    return result
}


export const getCopierInfo = async ({ accountId, masterAccount }: { accountId: string, masterAccount: string }) => {
    const param = {
        config: {},
        accountId,
        masterAccount,
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await inqService.getCopierInfo(param).then((data: any) => {
        const cvData = data.map((item: any) => {
            return {
                mt_fullname: item.fullname,
                afacctno: item.mtacctno,
                flstatus: item.status,
                ...item
            }
        })
        result = {
            isSuccess: true,
            data: cvData,
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getCopierInfo'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

export const getCopierInfoExcludeStatusClose = async ({ accountId, masterAccount }: { accountId: string, masterAccount: string }) => {
    const param = {
        config: {},
        accountId,
        masterAccount,
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await inqService.getCopierInfo(param).then((data: any) => {
        const cvData = data.filter((item: any) => {
            return item?.status !== STATUS_ACCOUNT.C
        }).map((item: any) => {
            return {
                mt_fullname: item.fullname,
                afacctno: item.mtacctno,
                flstatus: item.status,
                r_1_mon: item.twr_1_mon,
                r_3_mon: item.twr_3_mon,
                r_6_mon: item.twr_6_mon,
                ...item
            }
        })
        result = {
            isSuccess: true,
            data: cvData,
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getCopierInfo'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

export const submitExtendCopier = async (body: { accountId: string, masterAccount: string, amount: number, linkAccount: string }, dataVerify: any) => {
    const param = {
        config: {},
        body,
        dataVerify
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await userDataService.extendCopier(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: {}
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.submitExtendCopier'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

export const getPreviewBeforeStopCopy = async ({ accountId, masterAccount }: { accountId: string, masterAccount: string }) => {
    const param = {
        config: {},
        accountId,
        masterAccount,
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await inqService.getPreviewBeforeStopCopy(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: data[0],
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getPreviewBeforeStopCopy'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

export const submitStopCopy = async (body: { accountId: string, masterAccount: string, option: string }, dataVerify: any) => {
    const param = {
        config: {},
        body,
        dataVerify
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await userDataService.stopCopy(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: {}
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.submitStopCopy'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

export const getMoreInfoFollowers = async ({ accountId, masterAccount }: { accountId: string, masterAccount: string }) => {
    const param = {
        config: {},
        accountId,
        masterAccount,
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await inqService.getMoreInfoFollowers(param).then((data: any) => {
        const cvData = {
            mt_fullname: data[0].fullname,
            ...data[0]
        }
        result = {
            isSuccess: true,
            data: cvData,
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getMoreInfoFollowers'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

export const submitDeleteAccountFollower = async ({ accountId, dataVerify }: { accountId: string, dataVerify: any }) => {
    const param = {
        config: {},
        accountId,
        dataVerify,
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await userDataService.deleteAccountFollower(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: {}
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.submitDeleteAccountFollower'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

export type SubmitFavMaster = { accountId: string, action: 'F' | 'U', masterCustodycd: string, masterAccountId: string }

export const submitFavMasterTrader = async ({ accountId, action, masterCustodycd, masterAccountId }: SubmitFavMaster) => {
    const param = {
        config: {},
        body: {
            accountId,
            masterCustodycd,
            masterAccountId,
            action,
        }
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await userDataService.favMasterAccount(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: {}
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.submitFavMasterTrader'))
        result = {
            isSuccess: false,
        }
    })
    return result
}


// ls lãi lỗi

const prepareDataForChartPNL = (raw: any) => {
    const dataForChart: DataSeriesArray = [
        { id: 'pnl_date', type: 'XAxis', value: [] },
        { id: 'pnl', type: 'YAxis', value: [] },
    ]

    for (let index = 0; index < raw.length; index++) {
        const element = raw[index];
        dataForChart?.[0].value.push(element.pnl_date)
        dataForChart?.[1].value.push(element.pnl)
    }

    return dataForChart
}

export const getPNLHistory = async (accountId: string, masterAccount: string = '', cosrole: string = COS_ROLE.M, timePeriod: number = 1, timeType: string = "M") => {
    const param = {
        config: {},
        accountId,
        masterAccount,
        cosrole,
        timePeriod,
        timeType
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await inqService.pnlDaily(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: prepareDataForChartPNL(data),
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getPNLHistory'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

export const getPnlDailyPublic = async (accountId: string, masterAccount: string = '', cosrole: string = COS_ROLE.M, timePeriod: number = 1, timeType: string = "M") => {
    const param = {
        config: {},
        accountId,
        masterAccount,
        cosrole,
        timePeriod,
        timeType
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await inqService.pnlDailyPublic(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: prepareDataForChartPNL(data),
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getPNLHistory'))
        result = {
            isSuccess: false,
        }
    })
    return result
}


// thống kê sao chép Master

const prepareDataForChartCopyStatistic = (raw: any) => {
    const dataForChart: DataSeriesArray = [
        { id: 'on_date', type: 'XAxis', value: [] },
        { id: 'copier_number', type: 'YAxis', value: [] },
        { id: 'total_copy_amount', type: 'YAxis', value: [] },
    ]

    for (let index = 0; index < raw.length; index++) {
        const element = raw[index];
        dataForChart?.[0].value.push(formatDate(element.on_date))
        dataForChart?.[1].value.push(element.copier_number)
        dataForChart?.[2].value.push(element.total_copy_amount)
    }

    return dataForChart
}

export const getCopyStatisticPublic = async (accountId: string, periodTime: string, periodUnit: string) => {
    const param = {
        config: {},
        accountId,
        periodTime,
        periodUnit
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.copyStatisticPublic(param)
        result = {
            isSuccess: true,
            data: prepareDataForChartCopyStatistic(data),
        }
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getCopyStatistic'))
        result = {
            isSuccess: false,
        }
    }
    return result
}

export const getCopyStatisticPrivate = async (accountId: string, periodTime: string, periodUnit: string) => {
    const param = {
        config: {},
        accountId,
        periodTime,
        periodUnit
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.copyStatisticPrivate(param)
        result = {
            isSuccess: true,
            data: prepareDataForChartCopyStatistic(data),
        }
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getCopyStatistic'))
        result = {
            isSuccess: false,
        }
    }
    return result
}

const cv2ResponseSuccessPagination = (data: any, pageSize: number, pageIndex: number): ResponseSuccessPagination => {
    return {
        data: data,
        pageIndex: pageIndex,
        pageSize: pageSize || 0,
        total: data?.[0]?.row_count ?? (data?.length < pageSize ? data?.length : null) ?? 0
    }
}

export const getHistoryCopyTrans = async ({ accountId, masterAccount, fromDate, pageIndex, pageSize, toDate }: {
    accountId: string,
    masterAccount: string,
    fromDate: string,
    toDate: string,
    pageSize: number,
    pageIndex: number,
}) => {
    const param = {
        config: {},
        accountId,
        masterAccount,
        fromDate,
        toDate,
        pageSize,
        pageIndex,
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.getCopyTransHist(param)
        result = {
            isSuccess: true,
            data: cv2ResponseSuccessPagination(data, pageSize, pageIndex),
        }
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getHistoryCopyTrans'))
        result = {
            isSuccess: false,
        }
    }
    return result
}

export const getHistoryCalculationFee = async ({ accountId, masterAccount, fromDate, pageIndex, pageSize, toDate, status }: {
    accountId: string,
    masterAccount: string,
    fromDate: string,
    toDate: string,
    pageSize: number,
    pageIndex: number,
    status: string
}) => {
    const param = {
        config: {},
        accountId,
        masterAccount,
        fromDate,
        toDate,
        pageSize,
        pageIndex,
        status,
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.getFeeManagement(param)
        result = {
            isSuccess: true,
            data: cv2ResponseSuccessPagination(data, pageSize, pageIndex),
        }
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getHistoryCalculationFee'))
        result = {
            isSuccess: false,
        }
    }
    return result
}


export const getOrderHistoryFollower = async ({ accountId, masterAccount, fromDate, pageIndex, pageSize, toDate }: {
    accountId: string,
    masterAccount: string,
    fromDate: string,
    toDate: string,
    pageSize: number,
    pageIndex: number,
}) => {
    const param = {
        config: {},
        acctno: accountId,
        mtacctno: masterAccount,
        fromDate,
        toDate,
        pageSize,
        pageIndex,
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.ordersHistoryPrivate(param)
        result = {
            isSuccess: true,
            data: cv2ResponseSuccessPagination(data, pageSize, pageIndex),
        }
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getOrderHistoryFollower'))
        result = {
            isSuccess: false,
        }
    }
    return result
}

export const getPNLHistoryFollower = async ({ accountId, masterAccount, fromDate, pageIndex, pageSize, toDate }: {
    accountId: string,
    masterAccount: string,
    fromDate: string,
    toDate: string,
    pageSize: number,
    pageIndex: number,
}) => {
    const param = {
        config: {},
        accountId,
        masterAccount: masterAccount,
        fromDate,
        toDate,
        pageSize,
        pageIndex,
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.getPnlDetailsHist(param)
        result = {
            isSuccess: true,
            data: cv2ResponseSuccessPagination(data, pageSize, pageIndex),
        }

    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getPNLHistoryFollower'))
        result = {
            isSuccess: false,
        }
    }
    return result
}

export const getCashStatementsFollower = async ({ accountId, masterAccount, fromDate, pageIndex, pageSize, toDate }: {
    accountId: string,
    masterAccount: string,
    fromDate: string,
    toDate: string,
    pageSize: number,
    pageIndex: number,
}) => {
    const param = {
        config: {},
        accountId,
        masterAccount: masterAccount,
        fromDate,
        toDate,
        pageSize,
        pageIndex,
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.getCashStatements(param)
        result = {
            isSuccess: true,
            data: cv2ResponseSuccessPagination(data, pageSize, pageIndex),
        }

    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getCashStatementsFollower'))
        result = {
            isSuccess: false,
        }
    }
    return result
}

export const getStocksStatementsFollower = async ({ accountId, masterAccount, fromDate, pageIndex, pageSize, toDate, symbol }: {
    accountId: string,
    masterAccount: string,
    fromDate: string,
    toDate: string,
    pageSize: number,
    pageIndex: number,
    symbol: string,
}) => {
    const param = {
        config: {},
        accountId,
        masterAccount: masterAccount,
        fromDate,
        toDate,
        pageSize,
        pageIndex,
        symbol,
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.getStocksStatements(param)
        result = {
            isSuccess: true,
            data: cv2ResponseSuccessPagination(data, pageSize, pageIndex),
        }

    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getStocksStatementsFollower'))
        result = {
            isSuccess: false,
        }
    }
    return result
}

export const MIN_VALUE_CHART = 0.01 / 100 //(%)

const prepareDataForChartAllocPortfolios = (raw: any) => {
    const dataForChart: { name: string, value: number }[] = []
    const Other = { name: "Khác", value: 0 }

    for (let index = 0; index < raw.length; index++) {
        const element = raw[index];
        // if (element?.assetrate >= MIN_VALUE_CHART) {
        dataForChart.push({
            value: element?.assetrate,
            name: element?.symbol
        })
        // } else if (element?.assetrate && element?.assetrate !== 0) {
        //     Other.value = Other.value + parseFloat(element?.assetrate)
        // }
    }

    // if (Other && Other.value !== 0) {
    //     dataForChart.push(Other)
    // }
    return dataForChart
}

export const getAllocPortfoliosFollower = async (accountId: string, masterAccount: string = '',) => {
    const param = {
        config: {},
        accountId,
        masterAccount,
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await inqService.getAllocPortfolios(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: prepareDataForChartAllocPortfolios(data),
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getAllocPortfoliosFollower'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

export const getAllocPortfolios = async (accountId: string, masterAccount: string = '',) => {
    const param = {
        config: {},
        accountId,
        masterAccount,
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await inqService.getAllocPortfolios(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: data,
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getAllocPortfolios'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

export const submitWithdrawCash = async (body: { accountId: string, masterAccount: string, amount: number, linkAccount: string }, dataVerify: any) => {
    const param = {
        config: {},
        body,
        dataVerify
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await userDataService.withdrawCash(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: {}
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.submitWithdrawCash'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

export const getPortfoliosPrivate = async (accountId: string, masterAccount: string, pageIndex: number, pageSize: number) => {
    const param = {
        config: {},
        accountId,
        masterAccount,
        pageSize,
        pageIndex
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.getPortfoliosPrivate(param)
        result = {
            isSuccess: true,
            data: data,
        }
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getPortfoliosSelf'))
        result = {
            isSuccess: false,
        }
    }
    return result
}

export const getPortfoliosSelfTotal = async (accountId: string, masterAccount: string, pageIndex: number, pageSize: number) => {
    const param = {
        config: {},
        accountId,
        masterAccount,
        pageSize,
        pageIndex
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.getPortfoliosSelfTotal(param)
        result = {
            isSuccess: true,
            data: data,
        }
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getPortfoliosSelf'))
        result = {
            isSuccess: false,
        }
    }
    return result
}

export const getCopyPortfoliosStuck = async ({ accountId, masterAccount, pageIndex, pageSize }: { accountId: string, masterAccount: string, pageIndex: number, pageSize: number }) => {
    const param = {
        config: {},
        accountId,
        masterAccount,
        pageSize,
        pageIndex
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.getCopyStuckStock(param)
        result = {
            isSuccess: true,
            data: cv2ResponseSuccessPagination(data, pageSize, pageIndex),
        }
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getCopyPortfoliosStuck'))
        result = {
            isSuccess: false,
        }
    }
    return result
}

type ResponseItemOrder = {
    msg: string,
    symbol: string,
    quantity: number,
    code: string,
    masterAccount: string,
    price: number
}

export type ListResponse = { successMsgList: any[], errorMsgList: any[] }

const processListResponse = (res: any): ListResponse => {
    const successList = res.filter((item: ResponseItemOrder) => {
        return item?.code === "0"
    })

    const errList = res.filter((item: ResponseItemOrder) => {
        return item?.code !== "0"
    })

    const successMsgList: never[] = successList.map((item: ResponseItemOrder) => {
        return `${item.symbol} - ${i18next.t('copytrade.common.success')}`
    })
    const errorMsgList: never[] = errList.map((item: ResponseItemOrder) => {
        return `${item.symbol} - ${item.msg}`
    })

    return { successMsgList, errorMsgList }
}

export const submitSellPortfoliosStuck = async (body: { accountId: string, dataForPost: any, dataVerify: any }) => {
    const param = {
        config: {},
        body
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await TransactionService.sellCopyPortfoliosStuck(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: processListResponse(data?.details ?? [])
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.submitSellPortfoliosStuck'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

export const getCopyPortfoliosOddLot = async ({ accountId, masterAccount, pageIndex, pageSize }: { accountId: string, masterAccount: string, pageIndex: number, pageSize: number }) => {
    const param = {
        config: {},
        accountId,
        masterAccount,
        pageSize,
        pageIndex
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data = await inqService.getCopyOddLotStock(param)
        result = {
            isSuccess: true,
            data: cv2ResponseSuccessPagination(data, pageSize, pageIndex),
        }
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.getCopyPortfoliosOddLot'))
        result = {
            isSuccess: false,
        }
    }
    return result
}

export const submitSellPortfoliosOddLot = async (body: { accountId: string, dataForPost: any, dataVerify: any }) => {
    const param = {
        config: {},
        body
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    await TransactionService.sellCopyPortfoliosOddLot(param).then((data: any) => {
        result = {
            isSuccess: true,
            data: processListResponse(data?.details ?? [])
        }
    }).catch(error => {
        ToastUtil.errorApi(error, i18next.t('msgApi.error.submitSellPortfoliosOddLot'))
        result = {
            isSuccess: false,
        }
    })
    return result
}

export const getMasterCopyConfig = async ({ accountId, masterAccount }: { accountId: string, masterAccount: string }) => {
    const param = {
        config: {},
        accountId,
        masterAccount,
    }
    let result: ResponseSuccess = {
        isSuccess: false,
        data: null
    }
    try {
        const data: any = await inqService.getMasterCopyConfig(param)
        result = {
            isSuccess: true,
            data: data?.[0] ?? []
        }
    } catch (error) {
        ToastUtil.errorApi(error, i18next.t("msgApi.error.getMasterCopyConfig"))
        result = {
            isSuccess: false,
        }
    }
    return result
}